<div class="divBackGround">
  <div class="glass_container center_glassContainer">
    <div class="center_item">
        <p style="font-size: xx-large;" *ngIf="true">No pudimos cargar correctamente la configuración de tu usuario, por favor contacte al administrador o intente mas tarde.</p>
    </div>
    <div class="imgLogo">
      <mat-icon class="icon">error</mat-icon>
    </div>
  </div>
</div>